var _defs, _rect, _circle, _circle2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2.485 0 516.97 338.019",
    width: 516.97,
    height: 338.019,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cad8dd;}.cls-2{fill:#a1b9bf;}.cls-3{fill:#e85454;}.cls-4{fill:#ffa840;}.cls-5{fill:#dde5e8;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 512,
    height: 332.8,
    rx: 64,
    ry: 64,
    y: 1.6,
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 7.105427357601002e-15)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 128 270.4 L 76.8 270.4 C 66.947 270.4 60.788 259.733 65.715 251.2 C 68.001 247.24 72.227 244.8 76.8 244.8 L 128 244.8 C 137.853 244.8 144.012 255.467 139.085 264 C 136.799 267.96 132.573 270.4 128 270.4 Z",
    style: {
      transformOrigin: "102.4px 257.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 230.4 270.4 L 179.2 270.4 C 169.347 270.4 163.188 259.733 168.115 251.2 C 170.401 247.24 174.627 244.8 179.2 244.8 L 230.4 244.8 C 240.253 244.8 246.412 255.467 241.485 264 C 239.199 267.96 234.973 270.4 230.4 270.4 L 230.4 270.4 Z",
    style: {
      transformOrigin: "204.8px 257.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 332.8 270.4 L 281.6 270.4 C 271.747 270.4 265.588 259.733 270.515 251.2 C 272.801 247.24 277.027 244.8 281.6 244.8 L 332.8 244.8 C 342.653 244.8 348.812 255.467 343.885 264 C 341.599 267.96 337.373 270.4 332.8 270.4 Z",
    style: {
      transformOrigin: "307.2px 257.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 435.2 270.4 L 384 270.4 C 374.147 270.4 367.988 259.733 372.915 251.2 C 375.201 247.24 379.427 244.8 384 244.8 L 435.2 244.8 C 445.053 244.8 451.212 255.467 446.285 264 C 443.999 267.96 439.773 270.4 435.2 270.4 Z",
    style: {
      transformOrigin: "409.6px 257.6px"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 339.2,
    cy: 110.4,
    r: 44.8,
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 7.105427357601002e-15)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 403.2,
    cy: 110.4,
    r: 44.8,
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 7.105427357601002e-15)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 64,
    y: 65.6,
    width: 102.4,
    height: 89.6,
    rx: 31.2,
    ry: 31.2,
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 7.105427357601002e-15)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e54f2c335b834f98c8e4f79b2010aab4.svg";
export { ForwardRef as ReactComponent };